<template>
  <div style="padding: 0px" class="sub-view">
    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Tanggal Upload</th>
          <th>Periode</th>
          <th>Nama Dokumen</th>
          <th style="width: 20%">Tipe</th>
          <th>Review</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr
          :key="penggajian.timestamp._seconds"
          v-for="penggajian in riwayatPenggajian"
        >
          <!-- tanggal upload -->
          <td>{{ toDate(penggajian.tanggalPengajuan._seconds) }}</td>
          <!-- periode penggajian -->
          <td>{{ toMonth(penggajian.timestamp._seconds) }}</td>
          <!-- nama file -->
          <td>
            <p
              @click="openDokumen(penggajian.lampiranUrl[0])"
              class="clickable"
            >
              <svg
                style="margin-right: 6px"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.3433 13.0001V17.0001C19.3433 17.5305 19.1325 18.0392 18.7575 18.4143C18.3824 18.7894 17.8737 19.0001 17.3433 19.0001H3.34326C2.81283 19.0001 2.30412 18.7894 1.92905 18.4143C1.55398 18.0392 1.34326 17.5305 1.34326 17.0001V13.0001M5.34326 8L10.3433 13M10.3433 13L15.3433 8M10.3433 13V1"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {{ penggajian.judul }}
            </p>
            <p>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5714 11.1412V9.99833C10.5714 9.39212 10.3306 8.81074 9.90197 8.310248C9.47332 7.95343 8.89194 7.71261 8.28573 7.71261H3.7143C3.10809 7.71261 2.52671 7.95343 2.09806 8.310248C1.6694 8.81074 1.42859 9.39212 1.42859 9.99833V11.1412M8.28573 3.14118C8.28573 4.40355 7.26238 5.4269 6.00002 5.4269C4.73765 5.4269 3.7143 4.40355 3.7143 3.14118C3.7143 1.87882 4.73765 0.855469 6.00002 0.855469C7.26238 0.855469 8.28573 1.87882 8.28573 3.14118Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ penggajian.namaKaryawan }}
            </p>
          </td>
          <!-- tipe/status -->
          <td>
            <div
              v-if="penggajian.tipe === `revisi`"
              class="status-rounded-pending"
            >
              Revisi
            </div>
            <div v-else class="status-rounded-accepted">Normal</div>
          </td>
          <!-- review -->
          <td v-if="penggajian.status === 'accepted'" class="hasil-review-acc">
            <p class="detail-review">
              <span>ACC</span>
            </p>
            <p>oleh {{ penggajian.namaReviewer }}</p>
          </td>
          <td v-else class="hasil-review-tolak">
            <p class="detail-review">
              <span>TOLAK</span>
            </p>
            <p>oleh {{ penggajian.namaReviewer }}</p>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p v-if="isProsesData" class="empty-state-table">Memproses data..</p>
      <p
        v-else-if="!riwayatPenggajian || riwayatPenggajian.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>
  </div>
</template>

<script>
import * as soluhaApi from "@/soluhaApi";
import * as soluhafire from "@/soluhafire";

export default {
  data() {
    return {
      riwayatPenggajian: [],
      // apakah tabel sedang memproses data?
      isProsesData: false,
    };
  },

  methods: {
    async getRiwayat() {
      this.isProsesData = true;
      let riwayat = await soluhaApi.riwayatPenggajian();
      riwayat = riwayat.filter((item) => item.status !== "pending");
      this.riwayatPenggajian = riwayat;
      this.isProsesData = false;
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    toMonth(time) {
      let date = new Date(time * 1000);
      let month = date.getMonth();
      return soluhafire.NAMA_BULAN[month];
    },

    openDokumen(url) {
      window.open(url, "_blank");
    },
  },

  mounted() {
    this.getRiwayat();
  },
};
</script>
